
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, ArrowLeft, Calendar } from 'lucide-react';
import NavBar from '@/components/layout/NavBar';
import Footer from '@/components/layout/Footer';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/components/i18n/language-provider';

const ThankYou = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div className="min-h-screen flex flex-col">
      <NavBar />
      <main className="flex-grow container mx-auto px-4 py-16">
        <div className="max-w-3xl mx-auto text-center">
          <div className="mb-8 inline-flex items-center justify-center w-20 h-20 rounded-full bg-primary/10">
            <Heart className="h-10 w-10 text-primary" />
          </div>
          <h1 className="text-4xl font-bold mb-6">You're Important to Us</h1>
          <p className="text-xl text-muted-foreground mb-6">
            Thank you for reaching out! We've received your message and our team is reviewing it.
          </p>
          <p className="text-lg mb-10">
            We aim to respond to all inquiries within 12-48 hours during business days. Our team is committed to providing you with the best solution for your needs.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Button 
              onClick={() => navigate('/')}
              variant="outline"
              className="gap-2"
            >
              <ArrowLeft className="h-4 w-4" />
              Return to Home
            </Button>
            <Button 
              onClick={() => window.open("https://meetings-na2.hubspot.com/gilmar/demo-keystle-website", "_blank")}
              className="gap-2"
            >
              <Calendar className="h-4 w-4" />
              Schedule a Demo
            </Button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ThankYou;
